import { helper } from '@ember/component/helper';

import { isUnset } from 'rise-ui/utils/nullish.js';

export default helper(function isUnsetHelper(params) {
  return params.every(isUnset);
});
